import React from 'react'

const EmptyMessage = ({msg, children}) => <div className="empty-message">{children}{ msg || 'No data to display'}</div>

export default EmptyMessage
